var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFile = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 38,
    viewBox: "0 0 42 38",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 39,
    height: 36,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 17V11.5L26.5 17H21ZM14 10C12.89 10 12 10.89 12 12V28C12 28.5304 12.2107 29.0391 12.5858 29.4142C12.9609 29.7893 13.4696 30 14 30H26C26.5304 30 27.0391 29.7893 27.4142 29.4142C27.7893 29.0391 28 28.5304 28 28V16L22 10H14Z",
    fill: "#0029FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9987 0.832031C39.3029 0.832031 41.1654 2.69453 41.1654 4.9987C41.1654 7.30287 39.3029 9.16537 36.9987 9.16537C34.6945 9.16537 32.832 7.30287 32.832 4.9987C32.832 2.69453 34.6945 0.832031 36.9987 0.832031ZM38.4945 2.91536L36.9987 4.4112L35.5029 2.91536L34.9154 3.50286L36.4112 4.9987L34.9154 6.49453L35.5029 7.08203L36.9987 5.5862L38.4945 7.08203L39.082 6.49453L37.5862 4.9987L39.082 3.50286L38.4945 2.91536Z",
    fill: "#0029FF"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/file.155ba32d.svg";
export { ForwardRef as ReactComponent };